import { render, staticRenderFns } from "./SeekerDashboard.vue?vue&type=template&id=0018ba68&scoped=true"
import script from "./SeekerDashboard.vue?vue&type=script&lang=js"
export * from "./SeekerDashboard.vue?vue&type=script&lang=js"
import style0 from "./SeekerDashboard.vue?vue&type=style&index=0&id=0018ba68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0018ba68",
  null
  
)

export default component.exports